import * as React from "react";
import { Redirect, useLocation } from "react-router-dom";

import { useIsRouteEnabled } from "components/navigation/hooks/useIsRouteEnabled";
import {
    BAM_USERS_ROUTE,
    deriveRedirectTarget,
    detectApplicationFromPath,
    USERS_ROUTE,
} from "components/router/Routes";
import { Application } from "store/application";

export default function UsersView(): JSX.Element {
    const { pathname } = useLocation();
    const isRouteEnabled = useIsRouteEnabled();

    const route = detectApplicationFromPath(pathname) === Application.BAM ? BAM_USERS_ROUTE : USERS_ROUTE;
    const target = deriveRedirectTarget(route, isRouteEnabled);

    return <Redirect to={target.path} />;
}
